import styled from "styled-components";

export const QuestionMark = styled.div`
  margin-left: 10px !important;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding: 5px;

  :hover {
    > div {
      width: max-content;
      max-width: 400px;
      opacity: 1;
      transform: scale(1);
      z-index: 100;
    }
  }
`;
export const Explanation = styled.div`
  position: absolute;
  transform: scale(0);
  opacity: 0;
  left: 30px;
  padding: 8px;
  background-color: #f0f0f0;
  border-radius: 5px;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.3);
  transition: transform 0.1s ease;

  > img {
    max-width: 700px;
    margin-top: 15px;
  }
`;
